import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";


const getAllPatients = (clinicId, pageNo = 0, pageSize = 20, query = '') => {
    const params = new URLSearchParams({
        pageNo: String(pageNo),
        pageSize: String(pageSize),
    });

    if (query) {
        params.set('q', query);
    }

    return axios.get(`${API_URL}clinics/${clinicId}/patients?${params.toString()}`);
};

const getPatientById = (clinicId,patientId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId) 
}
const updatePatientDetails = (clinicId,patientId,data) =>{
    return axios.put(API_URL+"clinics/"+clinicId+"/patients/"+patientId,data)
}
const getCommunicationPreferences = (clinicId,patientId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/comm-prefs")
}

const updateCommunicationPreferences = (clinicId,patientId,data)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/comm-prefs",data)
}

const getPatientInvalidDetails = (clinicId,patientId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/invalid-details")
}

const getInvalidDetailsList = (clinicId, pageNo = 0, pageSize = 20, query = '') => {
    const params = new URLSearchParams({
        no: String(pageNo),
        size: String(pageSize),
    });

    if (query) {
        params.set('q', query);
    }

    return axios.get(`${API_URL}clinics/${clinicId}/invalid-details?${params.toString()}`);
};

const deleteInvalidDetails = (clinicId, detailIds, patientId = null) => {
    const url = patientId
        ? `${API_URL}clinics/${clinicId}/patients/${patientId}/invalid-details`
        : `${API_URL}clinics/${clinicId}/invalid-details`;

    return axios.delete(url, { data: detailIds });
};

const updatePatientInvalidDetails = (clinicId,patientId,data)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/invalid-details",data)
}
const getPatientAppointments = (clinicId, patientId, pageNo = 0, pageSize = 20) => {
    const params = new URLSearchParams({
        pageNo: String(pageNo),
        pageSize: String(pageSize),
    });

    return axios.get(`${API_URL}clinics/${clinicId}/patients/${patientId}/appointments?${params.toString()}`);
};

const getPatientActivities = (clinicId, patientId, pageNo = 0, pageSize = 20) => {
    const params = new URLSearchParams({
        no: String(pageNo),
        size: String(pageSize),
    });

    return axios.get(`${API_URL}clinics/${clinicId}/patients/${patientId}/activity?${params.toString()}`);
};

const patientService = {
    getAllPatients,
    getPatientById,
    updatePatientDetails,
    getCommunicationPreferences,
    updateCommunicationPreferences,
    getPatientInvalidDetails,
    getPatientInvalidData: getPatientInvalidDetails,
    getInvalidDetailsList,
    deleteInvalidDetails,
    deletePatientInvalidData: deleteInvalidDetails,
    updatePatientInvalidDetails,
    getPatientAppointments,
    getPatientActivities,
}

export default patientService